export default {"src":"/_next/static/media/SVGServices02.04211f8a.svg","height":679,"width":796};